import React, { type ComponentType, useContext } from 'react'
import { AuthContext } from '../../context/auth/auth-context'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import PageLoader from './page-loader'
import NotAuthorizedPage from '../../pages/navigation/not-authorized-page'

interface AuthorizationGuardProps {
  Component: ComponentType<any>
  [key: string]: any
}

const AuthorizationGuard: React.FC<AuthorizationGuardProps> = ({
  Component, ...props
}) => {
  const TransitionComponent: React.FC<React.ComponentProps<typeof Component>> = withAuthenticationRequired(
    NotAuthorizedPage,
    {
      onRedirecting: () => (
        <div style={{ width: '100%', height: '100%', backgroundColor: '#121212' }}>
          <PageLoader/>
        </div>
      ),
    })

  const { isLoading, isAuthenticated, isAuthorized, requestedResources } = useContext(AuthContext)

  if (isLoading) {
    return (
      <div style={{ width: '100%', height: '100%', backgroundColor: '#121212' }}>
        <PageLoader/>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <TransitionComponent {...props}/>
    )
  }

  if (!isAuthorized) {
    return (
      <NotAuthorizedPage requestedResources={requestedResources}/>
    )
  }

  return (
    <Component {...props}/>
  )
}

export default AuthorizationGuard
